import { validateProfile } from "@helpers/validateProfileFills";
import { NetworkingFillStatus } from "@interface/enums";
import { showAlert } from "@helpers/showAlert";
import * as Middleware from "@middlewares/index";
import * as Model from "@models/index";
import { History } from "history";

function isNetworkingProfileEmpty(profile: any): boolean {
  return (
    (!profile?.interestCompanyTypes ||
      profile?.interestCompanyTypes?.length === 0) &&
    (!profile?.languages || profile?.languages?.length === 0) &&
    (!profile?.directions || profile?.directions?.length === 0) &&
    (!profile?.specializations || profile?.specializations?.length === 0) &&
    (!profile?.about || profile.about.length === 0)
  );
}

export const validationEndConnectionNetworking = async (
  history: History,
  profileData: any
) => {
  try {
    const validation = validateProfile(profileData).missingFields;

    const navigateWithValidation = (path: string) => {
      history.push({
        pathname: path,
        state: { showValidationAlert: true, missingFields: validation },
      });
    };

    // Сначала проверка - заполнен ли личный профиль
    if (
      profileData.networkingFillStatus ===
      NetworkingFillStatus.IncompleteProfile
    ) {
      showAlert({ text: "Заполните недостающие данные!", status: "danger" });
      navigateWithValidation("/cabinet/profile");
      return { status: "error", missingFields: validation };
    }

    // Потом проверка, что профиль нетворкинга вообще не заполнялся
    if (isNetworkingProfileEmpty(profileData.networkingProfile)) {
      history.push({ pathname: "/cabinet/networking/profile" });
      return { status: "error", missingFields: validation };
    }

    // Потом проверка, что отдельные поля не заполнены или же всё заполнено
    switch (profileData.networkingFillStatus) {
      case NetworkingFillStatus.Complete:
        await new Model.Profile().setNetworkingStatus(true);
        await Middleware.Profile.load();
        history.push({
          pathname: "/cabinet/networking/profile",
          state: { showCompleteAlert: true },
        });
        return { status: "complete", missingFields: validation };

      case NetworkingFillStatus.MissingNetworkingData:
        showAlert({
          text: "Заполните недостающие данные!",
          status: "danger",
        });
        navigateWithValidation("/cabinet/networking/profile");
        return { status: "error", missingFields: validation };

      case NetworkingFillStatus.NeedCompanyAssociation:
        showAlert({
          text: "Заполните недостающие данные!",
          status: "danger",
        });
        validation.push("companyAssociation");
        navigateWithValidation("/cabinet/networking/profile");
        return { status: "error", missingFields: validation };
      default:
        history.push({ pathname: "/cabinet/networking/profile" });
    }
  } catch (error) {
    console.error("Error setting networking status:", error);
  }
};
